import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import React, { useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { FilterSortContent } from "../constant";
import FilterData from "./FilterData";
import { sortlistorderbook } from "@frameworks/web/components/features/Offerings/SGB/constant";
import WatchlistSorting from "@frameworks/web/components/features/WatchList/CommonWatchlist/WatchlistSorting";
import BuySellBtn from "@frameworks/web/components/features/TOC/CommonTocComponent/Stock/BuySellBtn";
import { ESortOrder } from "@domains/utils/sort";
export var SORTFILTERTABS;
(function (SORTFILTERTABS) {
    SORTFILTERTABS["SORT"] = "SORT";
    SORTFILTERTABS["FILTER"] = "FILTER";
})(SORTFILTERTABS || (SORTFILTERTABS = {}));
const TabContent = (key, 
// Sort Params
sortState, resetSort, setSortState, handelSorting, setOpenSort, openDrawer, setOpenDrawer, sortList, 
// Filter Params
filterState, updateFilterState, setCustomDateFilter, customDateFilter, activeKey, cancelAndApply, hideSortDrawerHeader, setActiveKey) => {
    const device = DeviceContext();
    const [idx, setIdx] = React.useState();
    return (React.createElement(React.Fragment, null, key === SORTFILTERTABS.SORT ? (React.createElement("div", { className: "showSortDropdown insider funds-sort common-fund-sort" },
        React.createElement(WatchlistSorting, { parentClass: "watchlist-drawer orderbook-sorting", sortlist: sortList ? sortList : sortlistorderbook, sortingState: sortState, updateSortingState: setSortState, clearall: resetSort, isClearAll: true, setId: setIdx, handleSorting: () => { }, hideDrawerHeader: hideSortDrawerHeader }),
        cancelAndApply ? (React.createElement("div", { className: "bottom-contents px-3 p-2 topboxsshadow-button" },
            React.createElement(BuySellBtn, { rightButton: {
                    btnTyp: "midnight-blue",
                    value: "Apply",
                    className: "w-100",
                    disabled: sortState.every((y) => y.list.every((m) => m.order === ESortOrder.UNCHANGED)),
                    onClick: () => handelSorting(idx),
                }, cancelAction: () => setOpenDrawer(false), refreshLabelTitle: "" }))) : (React.createElement("div", { className: "bottom-contents px-3 p-3 topboxsshadow-button" },
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply Sorting", className: "w-100", onClick: () => handelSorting(idx) }))))) : (React.createElement(React.Fragment, null,
        React.createElement(FilterData, { filterState: filterState, updateFilterState: updateFilterState, setOpenDrawer: setOpenDrawer, setCustomDateFilter: setCustomDateFilter, customDateFilter: customDateFilter, activeKey: activeKey, cancelAndApply: cancelAndApply, setActiveKey: setActiveKey })))));
};
const SortFilter = (props) => {
    const [tab, setTab] = useState(props.sortOrFilterActiveKey
        ? props.sortOrFilterActiveKey
        : SORTFILTERTABS.SORT);
    const setTabValue = (key) => {
        props.setSelected && props.setSelected(key);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericTabs, { defaultActiveKey: tab, tabsArray: FilterSortContent.map((tab) => {
                return {
                    title: tab.title,
                    eventKey: tab.eventKey,
                    tabContent: TabContent(tab.eventKey, 
                    // Sort Arguments
                    props.sortState, props.resetSort, props.setSortState, props.handelSorting, props.setOpenSort, props.openDrawer, props.setOpenDrawer, props.sortList, 
                    // Filter Arguments
                    props.filterState, props.updateFilterState, props.setCustomDateFilter, props.customDateFilter, props.activeKey, props.cancelAndApply, props.hideSortDrawerHeader, props.setActiveKey),
                };
            }), externalClassName: "common-tab-color showborder sort-filter-mob-padding", callBackFunction: (key) => {
                setTabValue(key);
                setTab(key);
            } })));
};
export default SortFilter;
